import React, { useState } from "react";
import { Button, Checkbox, Paper, Typography, Box, Alert, FormControlLabel, Radio, FormGroup } from "@mui/material";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useTranslation } from "react-i18next";

export default function UploadPayments() {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [paymentType, setPaymentType] = useState("bank");
  const [actualizeData, setActualizeData] = useState(true);
  const paymentStore = useStore((s) => s.paymentStore);
  const { loading } = paymentStore;

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage(t("uploadPayments.selectCSV"));
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("paymentType", paymentType);

    if (actualizeData && paymentType === "block") {
      formData.append("actualizeData", actualizeData as any);
    }

    try {
      await paymentStore.uploadPaymentCsvData(formData);
      setMessage(t("uploadPayments.csvSuccessfullySent"));
    } catch (error) {
      setMessage(t("uploadPayments.csvError"));
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: "auto", mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t("uploadPayments.bank.title")}
      </Typography>
      {loading && <LoadingComponent content={t("general.loading")} />}
      {!loading && (
        <form>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {t("uploadPayments.selectType")}
            </Typography>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Radio
                    checked={paymentType === "bank"}
                    onChange={() => setPaymentType("bank")}
                  />
                }
                label={t("uploadPayments.bank.title")}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={paymentType === "block"}
                    onChange={() => setPaymentType("block")}
                  />
                }
                label={t("uploadPayments.block.title")}
              />
              {paymentType === "block" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={actualizeData}
                      onChange={(e) => setActualizeData(e.target.checked)}
                    />
                  }
                  label={t("uploadPayments.checkBoxActualize")}
                />
              )}
            </FormGroup>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {t(`uploadPayments.${paymentType}.selectFile`)}
            </Typography>
            <input
              type="file"
              accept={
                paymentType === "bank"
                  ? ".csv"
                  : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              }
              onChange={handleFileChange}
            />
            <Alert severity="info" sx={{ mt: 2 }}>
              <p>{t("uploadPayments.konto.format")}</p>
              {paymentType === "bank" && (
                <p>
                  "Auftragskonto"; "Buchungstag"; "Valutadatum"; "Buchungstext";
                  "Verwendungszweck"; "Beguenstigter/Zahlungspflichtiger";
                  "Kontonummer"; "BLZ"; "Betrag"; "Waehrung"; "Info"
                </p>
              )}
              {paymentType === "block" && (
                <div>
                  <p>
                    Mitgliedsnummer Nachname Vorname 2021 2022 2023 2024 Zahlungsart
                  </p>
                </div>
              )}
            </Alert>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={!file}
            fullWidth
            sx={{ mt: 2 }}
          >
            {t("uploadPayments.sendPayments")}
          </Button>
        </form>
      )}
      {message && (
        <Alert severity="info" sx={{ mt: 3 }}>
          {message}
        </Alert>
      )}
    </Paper>
  );
}
